import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = ({ onOpenModal }) => {
  return (
    <footer className="bg-white text-azure-600 py-12 border-t border-gray-100">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row items-center justify-between"
        >
          <div className="mb-4 md:mb-0">
            <Link to="/">
              <img
                src="https://github.com/mike3011/Bilder/blob/main/3.png?raw=true"
                alt="K³ Logo"
                className="h-8 w-auto"
              />
            </Link>
          </div>
          <div className="flex flex-wrap justify-center space-x-8">
            <Link
              to="/impressum"
              className="text-azure-600 hover:text-azure-700 transition-colors font-medium"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-azure-600 hover:text-azure-700 transition-colors font-medium"
            >
              Datenschutz
            </Link>
            <button
              onClick={() => onOpenModal('plgo')}
              className="text-azure-600 hover:text-azure-700 transition-colors font-medium"
            >
              PLGO
            </button>
          </div>
        </motion.div>
        <div className="border-t border-gray-200 mt-8 pt-8 text-center text-azure-600">
          <p>&copy; 2025 K³ - Nadine Rau u. Mike Trepte GbR. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;